'use strict';

class Accordion {
    setup (element = false) {
        this.accordionElement = element || $('.accordion');
        this.init();

        this.accordionElement.on('click', '.accordion-title', function (e) {
            e.preventDefault();
            const $accordion = $(this).closest('.accordion');
            const $item = $(this).closest('.accordion-item');
            const $itemclose = $(this).closest('.accordion-item.active');
            const $content = $(this).next('.accordion-content');
            const breakpoint = $accordion.data('accordion-size');

            const _toggleAccordionStatus = () => {
                $accordion.find('.accordion-content').not($content).removeClass('active').slideUp('fast');
                $accordion.find('.accordion-item').not($item).removeClass('active');
                $accordion.find('.accordion-item.active').not($itemclose).removeClass('active');

                $item.addClass('active');
                $content.slideDown('fast');
                $itemclose.removeClass('active');
            };

            if (breakpoint === 'small' && !Foundation.MediaQuery.atLeast('medium')) {
                _toggleAccordionStatus();
            } else if (breakpoint === 'medium' && !Foundation.MediaQuery.atLeast('large')) {
                _toggleAccordionStatus();
            } else if (breakpoint === 'tablet' && !Foundation.MediaQuery.atLeast('large')) {
                _toggleAccordionStatus();
            } else if (breakpoint === 'all') {
                _toggleAccordionStatus();
            }
        });
        // close at click
        this.accordionElement.on('click', '.accordion-item.active .accordion-title', function (e) {
            e.preventDefault();
            $(e.currentTarget).siblings('.accordion-content').slideUp('fast');
        });

        $(window).on('changed.zf.mediaquery', () => {
            this.init();
        });
    }

    init () {
        this.accordionElement.each(function () {
            const $accordion = $(this).closest('.accordion');
            const breakpoint = $accordion.data('accordion-size');

            if (breakpoint === 'small' && !Foundation.MediaQuery.atLeast('medium')) {
                $accordion.addClass('initialized');
                $accordion.find('.accordion-content').hide();
            } else if (breakpoint === 'medium' && !Foundation.MediaQuery.atLeast('large')) {
                $accordion.addClass('initialized');
                $accordion.find('.accordion-content').hide();
            } else if (breakpoint === 'tablet' && !Foundation.MediaQuery.atLeast('large')) {
                $accordion.addClass('initialized');
                $accordion.find('.accordion-content').hide();
            } else if (breakpoint !== 'all') {
                $accordion.removeClass('initialized');
                $accordion.find('.accordion-content').show();
            } else if (breakpoint === 'all') {
                $accordion.addClass('initialized');
                $accordion.find('.accordion-content').hide();
            }
        });
    }
}

const accordion = new Accordion();
export default accordion;
